// eslint-disable-next-line no-restricted-imports
import type { CSSObject } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';

interface InfiniteScrollThresholdProps {
  height?: CSSObject['height'];
}

/**
 * An invisible div that must be placed in a relative-positioned container.
 * Use this alongside react-intersection-observer to trigger a fetch of the next page
 *  of an api's results.
 */
export const InfiniteScrollThreshold = styled.div<InfiniteScrollThresholdProps>(
  ({ height = '40vh' }) => ({
    backgroundColor: 'transparent',
    bottom: 0,
    height,
    left: 0,
    position: 'absolute',
    right: 0,
    zIndex: -1,
  })
);
